import React, {useEffect, useState} from 'react';

const UpdateBanner = () => {
    const [showBanner, setShowBanner] = useState(false);
    const [latestVersion, setLatestVersion] = useState(null);

    useEffect(() => {
        // Текущая версия из мета-тега
        const currentVersion = document.querySelector('meta[name="app-version"]')?.content;

        // Функция проверки обновлений
        const checkForUpdates = async () => {
            try {
                // Добавляем timestamp, чтобы избежать кэширования запроса
                const response = await fetch(`/index.html?t=${Date.now()}`);
                const html = await response.text();

                // Парсим версию из нового index.html
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newVersion = doc.querySelector('meta[name="app-version"]')?.content;

                if (newVersion && currentVersion && newVersion !== currentVersion) {
                    setLatestVersion(newVersion);
                    setShowBanner(true);
                }
            } catch (error) {
                console.error('Failed to check for updates:', error);
            }
        };

        // Проверяем сразу при загрузке
        checkForUpdates();

        // И проверяем каждые 5 минут
        const interval = setInterval(checkForUpdates, 1 * 60 * 1000);

        return () => clearInterval(interval);
    }, []);

    const handleRefresh = () => {
        window.location.reload();
    };

    if (!showBanner) return null;

    return (
        <div style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            backgroundColor: '#2196F3',
            color: 'white',
            padding: '16px 24px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            maxWidth: '400px',
            animation: 'slideIn 0.3s ease-out'
        }}>
            <div>
                <strong style={{fontSize: '16px'}}>🔄 Доступна новая версия</strong>
                {latestVersion && (
                    <div style={{fontSize: '14px', marginTop: '4px', opacity: 0.9}}>
                        Версия: {latestVersion}
                    </div>
                )}
            </div>
            <button
                onClick={handleRefresh}
                style={{
                    backgroundColor: 'white',
                    color: '#2196F3',
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    fontSize: '14px',
                    whiteSpace: 'nowrap'
                }}
            >
                Обновить
            </button>
            <button
                onClick={() => setShowBanner(false)}
                style={{
                    background: 'transparent',
                    border: 'none',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: '20px',
                    padding: '0 4px'
                }}
            >
                ×
            </button>
        </div>
    );
};

export default UpdateBanner;